import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function RequireOffice({ children }) {
  const { isAuthenticated, isOffice, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-brand-gradient flex items-center justify-center text-white/80">
        Loading…
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/staff" replace />;
  if (!isOffice) return <Navigate to="/staff/app" replace />;
  return children;
}
